import { Text } from '@heathmont/moon-core';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';

const CategoryText = styled(Text)`
  && {
    padding: ${rem(4)};
    &:hover {
      background: ${({ theme }) => theme.color.goku[100]};
    }
  }
`;

export default CategoryText;
